import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { IconPlus } from "@tabler/icons-react";
import { useCRM } from "../CRMContext";
import Column from "./Column";

const Board = ({ onAddContact, onEditColumn, onDeleteColumn, onAddColumn, onMoveAll }) => {
  const { state } = useCRM();

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="crm-board">
        {state.columns.map((column, index) => (
          <Column
            key={`column-${column.id}`}
            column={column}
            index={index}
            onAddContact={onAddContact}
            onEditColumn={onEditColumn}
            onDeleteColumn={onDeleteColumn}
            onMoveAll={onMoveAll}
          />
        ))}

        <div className="crm-board__add-column" onClick={onAddColumn}>
          <IconPlus size={20} />
          <span>Adicionar Coluna</span>
        </div>
      </div>
    </DndProvider>
  );
};

export default Board;
